import styles from "./BottomLinks.css";
import classNames from "classnames";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";

const BottomLinks = ({ formatTranslation }) => {
  const termsLink = formatTranslation("quick_join_overlay_terms_link_web", {
    termslink: `<a href='https://www.asos.com/terms-and-conditions/?ctaref=${encodeURIComponent(
      "t&cs - quick join overlay"
    )}'>${formatTranslation("quick_join_overlay_terms_link_copy_web")}</a>`,
    privacypolicylink: `<a href='https://www.asos.com/privacy-policy/?ctaref=${encodeURIComponent(
      "privacy policy - quick join overlay"
    )}'>${formatTranslation(
      "quick_join_overlay_privacy_policy_link_copy_web"
    )}</a>`
  });

  return (
    <div
      className={classNames("leavesden4", styles.bottomLinks)}
      dangerouslySetInnerHTML={{ __html: termsLink }}
    />
  );
};

BottomLinks.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(BottomLinks);
